import { useState } from 'preact/hooks';

/** Show the first `step` rows and grow on demand. Keeps long lists (a year of sales) cheap to render. */
export function usePaged<T>(
  rows: ReadonlyArray<T>,
  step = 100,
): { visible: ReadonlyArray<T>; hasMore: boolean; more: () => void; total: number; shown: number } {
  const [limit, setLimit] = useState(step);
  const visible = rows.length > limit ? rows.slice(0, limit) : rows;
  return {
    visible,
    hasMore: rows.length > limit,
    more: () => setLimit(limit + step),
    total: rows.length,
    shown: visible.length,
  };
}
